import { FeatureFlagsDTOAPIModel } from '@/generated/api/fps/api';
import { PartnerAPIModel } from '@/generated/api/fps/core';

export const NAMESPACE = 'GLOBAL';

export interface State {
  application: ApplicationType;
  initialized: boolean;
  locale: string;
  viewState: ViewState;
  notifications: GlobalIdentifiedNotification[];
  partner?: Partner;
  toggle?: {
    flags: Partial<Record<FeatureFlags, boolean>>;
    error?: string;
  };
}

export enum ApplicationType {
  DEMO = 'demo',
  INVOICE = 'invoice',
  WITHDRAWAL = 'withdrawal',
  WALLET = 'wallet',
}

export interface ViewState {
  loading: boolean;
  messageId?: string;
  isFrame: boolean;
  isMobile: boolean;
  vh?: number;
}

export type Partner = PartnerAPIModel;

export type Severity = 'success' | 'info' | 'warning' | 'error';

export interface BaseGlobalNotification {
  severity: Severity;
  titleId?: string;
  type?: string;
}

export interface GlobalNotificationWithMessageId extends BaseGlobalNotification {
  messageId: string;
}

export interface GlobalNotificationWithMessage extends BaseGlobalNotification {
  message: string;
}

export type GlobalNotification = GlobalNotificationWithMessageId | GlobalNotificationWithMessage;
export type GlobalIdentifiedNotification = GlobalNotification & { id: string };

export enum UIState {
  IDENTIFICATION = 'identification',
  INVOICE = 'invoice',
  WITHDRAWAL = 'withdrawal',
  WALLETS = 'wallets',
  DEMO = 'demo',
}

export type FeatureFlags = keyof FeatureFlagsDTOAPIModel;

export const initialState: State = {
  application: ApplicationType.INVOICE,
  initialized: false,
  viewState: {
    isFrame: false,
    loading: false,
    isMobile: false,
  },
  notifications: [],
  locale: window.env.DEFAULT_LOCALE,
};
